import { Box, Table, TextField, TableBody, TableCell, Button, TableContainer, TableRow } from "@mui/material";
import { useState, useEffect } from "react";
import { getDiscount, addCouponCode } from "../clients/FixieApiClient";
import DashboardPage from "../layouts/DashboardPage";
import { FieldValues, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Discount } from "../models";
import { FormatDate } from "../components/FormatDate";

export default () => {
  const [isLoading, setIsLoading] = useState(false);
  const [discount, updateDiscountValue] = useState<Discount | null>(null);
  const { register, handleSubmit } = useForm();

  const fetchDiscount = async () => {
    setIsLoading(true);
    try {
      const response = await getDiscount();
      if (response.ok) {
        updateDiscountValue(await response.json());
      }
    } finally {
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: FieldValues) => {
    setIsLoading(true);
    const response = await addCouponCode(data);
    if (response.ok) {
      toast.success("Your discount has been added");
      fetchDiscount();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchDiscount();
  }, []);

  return (
    <DashboardPage title="Discount">
      <Box>
        <TableContainer>
          <Table>
            <colgroup>
                <col width="10%" />
                <col width="90%" />
            </colgroup>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  Current Discount
                </TableCell>
                <TableCell>
                  {discount && (
                    <Box>
                      {discount.name} (Expires on <FormatDate epoch={discount.end*1000} />)
                    </Box>
                  )}
                  {!discount && (
                    <Box>None</Box>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  Add Discount
                </TableCell>
                <TableCell>
                  <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
                    <TextField size="small" {...register('couponCodeToAdd')} required margin="dense" label="Coupon Code" type="coupon" variant="outlined" />
                    <Box>
                      <Button
                        disabled={isLoading}
                        disableElevation
                        variant="contained"
                        type="submit"
                      >
                        Add Coupon
                      </Button>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </DashboardPage>
  )
}
